import '../utils/Array'
import { IncursionPayout } from './IncursionPayouts'

class IncursionSite {
  minutes: number

  constructor(minutes: number) {
    this.minutes = minutes
  }
}

const getSitesFromPayouts = (payouts: Array<IncursionPayout>): Array<IncursionSite> => {
  return payouts
    .sort((left, right) => (left.timestamp.toMillis() - right.timestamp.toMillis()))
    .fold<[IncursionPayout, IncursionSite | null], IncursionPayout>([], (sites: Array<[IncursionPayout, IncursionSite | null]>, payout: IncursionPayout) => {
      return [payout, sites.length === 0 ? null : new IncursionSite((payout.timestamp.toMillis() - sites[sites.length - 1][0].timestamp.toMillis()) / (1000 * 60))]
    })
    .filter(([payout, site]) => site != null)
    .map(([payout, site]) => site as IncursionSite)
}

export { IncursionSite, getSitesFromPayouts }
